<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>考勤明细</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-container class="content-container">
      <!-- 侧边树 -->
      <el-aside width="18%" style="height:100%;background:#fff;" class="aside">
        <!-- <div style="height:13%">
          <el-input
            v-model="search.entName"
            placeholder="请输入企业班组名称"
            style="margin-bottom: 10px; width: 85%;margin-top: 20px;font-size:12px"
            clearable
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div> -->
        <el-card style="height:99%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            highlight-current
            @node-click="handleNodeClick"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <div class="build-bar">
          <div class="selectMon">
            <div>选择月份：</div>
            <el-date-picker
              type="month"
              placeholder="选择月份"
              v-model="searchDate"
              value-format="yyyy-MM"
              @change="doFilter"
            ></el-date-picker>
          </div>
          <span style="margin-left:20px">人员检索：</span>
          <el-input placeholder="请输入姓名" v-model="name"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin-left:1vh;">查询</el-button>
          <el-tooltip class="item" effect="dark" content="导出考勤明细表" placement="top-end" v-if="isMenuExit('pro:count:export')">
            <img  @click="addRow" class="icon_hover" src="../../assets/image/export.png" alt="" srcset="" style="margin-left: 1vw;">
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="出勤规则" placement="top-end" v-if="isMenuExit('pro:count:conf')">
            <img  class="icon_hover" @click="expendVisible =true" src="../../assets/image/tuo.png" alt="" srcset="" style="margin-left: 1vw;">
          </el-tooltip>
          <!-- <div style="margin-left:1vw;">
            <span>出勤规则:</span>
            <el-select
              v-model="minValue"
              clearable
              filterable
              placeholder="请选择最小时长"
              @change="filterName1"
              size="mini"
              class="select"
              style="width:5vw;"
            >
              <el-option v-for="item in startDay" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select
              v-model="maxValue "
              clearable
              filterable
              placeholder="请选择最大时长"
              @change="filterName2"
              size="mini"
              style="margin-left:20px;width:5vw;"
            >
              <el-option v-for="item in endDay" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <el-button type="primary" class="add-user" @click="addRow()" style="float:right;margin-left:1vh;">导出考勤明细表</el-button> -->
        </div>
        <div class="build-table" style="width:100%;">
          <el-table :data="tableDataEnd" border height="100%" style="width: 100%;">
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <el-table-column label="序号" width="80" fixed>
              <template slot-scope="scope">
                <span>{{ scope.row.index }}</span>
              </template>
            </el-table-column>
            <el-table-column label="姓名" fixed>
              <template slot-scope="scope">
                <a>{{ scope.row.personName}}</a>
              </template>
            </el-table-column>
            <el-table-column label="班组" fixed>
              <template slot-scope="scope">
                <a>{{ scope.row.teamsName}}</a>
              </template>
            </el-table-column>
            <el-table-column :label="item" v-for="item in dateList" :key="item" width="150">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.attendNum }}</span> -->
                <!-- <p class="tabP">上午上班：<span style="color:#f1911a;">{{ scope.row['day'+parseInt(item.split("-")[2])+'am1'] }}</span></p>
                <p class="tabP">上午下班：<span style="color:#f1911a;">{{ scope.row['day'+parseInt(item.split("-")[2])+'am2'] }}</span></p>
                <p class="tabP">下午上班：<span style="color:#f1911a;">{{ scope.row['day'+parseInt(item.split("-")[2])+'pm1'] }}</span></p>
                <p class="tabP">下午下班：<span style="color:#f1911a;">{{ scope.row['day'+parseInt(item.split("-")[2])+'pm2'] }}</span></p>-->
                <p class="tabP">
                  进场：
                  <span
                    v-if="scope.row[`workTime`+parseInt(item.split(`-`)[2])]!=-1"
                    style="color:#f1911a;"
                  >{{ scope.row['amDay'+parseInt(item.split("-")[2])] }}</span>
                </p>
                <p class="tabP">
                  出场：
                  <span
                    v-if="scope.row[`workTime`+parseInt(item.split(`-`)[2])]!=-1"
                    style="color:#f1911a;"
                  >{{ scope.row['pmDay'+parseInt(item.split("-")[2])] }}</span>
                </p>
                <p class="tabP">
                  时长：
                  <span
                    style="color:#f1911a;"
                    v-if="scope.row[`workTime`+parseInt(item.split(`-`)[2])]!=-1"
                  >{{ scope.row['workTime'+parseInt(item.split("-")[2])] }}</span>
                </p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="上班时长">
                  <template slot-scope="scope">
                    <span>{{ scope.row.workTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="加班天数">
                  <template slot-scope="scope">
                    <span>{{ scope.row.overtimeDays }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="加班时长">
                  <template slot-scope="scope">
                    <span>{{ scope.row.overtimeHours }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                  </template>
            </el-table-column>-->
          </el-table>
          <!-- 分页展示 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[3, 5, 10,20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
          ></el-pagination>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      title=""
      :visible.sync="expendVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="30%"
    >
      <template>
        <div  style="width:70%;margin:auto">
          <span>出勤规则：</span>
          <el-select
            v-model="minValue"
            clearable
            filterable
            placeholder="请选择最小时长"
            class="select"
            style="width:12vh;"
          >
            <el-option v-for="item in startDay" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-select
            v-model="maxValue"
            clearable
            filterable
            placeholder="请选择最大时长"
            style="margin-left:20px;width:12vh;"
          >
            <el-option v-for="item in endDay" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="expendVisible= false">取 消</el-button>
          <el-button type="primary" @click="doFilter">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      search:{
        entName:''
      },
      searchDate: util.myTime.getCurMonth(), //所选下拉框数据
      teamsId: '', //选择班组id
      dataTree: [], //表格搜索下拉框数据
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      dateList: [], //时间列表
      id: '', //当前人的id
      dataText: '数据加载中...',
      allCount: {
        allPerson: 0,
        managers: 0,
        workers: 0,
        mAttends: 0,
        registerTeams: 0
      },
      startDay: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
      ],
      endDay: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
      ],
      minValue: '0',
      maxValue: '24',
      name: '',
      defaultProps:{
          children: 'children',
          label: 'name'
      },
      expendVisible:false,
    }
  },
  created() {
    this.projectId = util.session.get('groupId')
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id
      this.searchDate = this.$route.params.month
      this.teamId = this.$route.params.team
    }
    this.getDateList()
    this.getTeam()
    this.getData()
    this.getNum()
  },
  methods: {
    getTeam() {
      var that = this
      myHttp.getEntTeams({
          projectId: this.projectId
      }).then(function(resp) {
          if (resp.data.code == '200') {
              var list = resp.data.data.list || []
              var tree = util.common.listToTree('id', 'parentId', list)
              var obj = [{ name: '全部', id: '', parentId: '', children: [] }]
              obj[0].children = tree
              that.dataTree = obj
          }
      })
    },
    //点击树
    handleNodeClick(data){
      console.log(1111111);
      this.currentPage = 1
      // if(data.type == '1'){
      //   this.search.entId = data.parentId
      //   this.teamsId = ''
      // }else 
      if(data.type == '0'){
        // this.search.entId = ''
        this.teamsId = data.id
      }
      this.getData()
    },
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.pageSize = 10
      this.getDateList()
      this.getData()
      this.getNum()
      this.expendVisible=false
      // this.currentChangePage()
    },
    //班组搜索
    doFilterTeam() {
      this.id = ''
      this.currentPage = 1
      this.currentChangePage()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var option = {
        teamsId: this.id == '' ? this.teamsId : this.id,
        projectId: this.projectId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        // year1: this.searchDate.split('-')[0],
        // month1: this.searchDate.split('-')[1],
        month: this.searchDate,
        maxValue: this.maxValue,
        minValue: this.minValue,
        name: this.name
        // personId: this.id
      }
      var that = this
      myHttp.findAllMonthAttendInfo(option).then(
        //myHttp.getStatisMonth(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            //console.log(resp)
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              // list[i].index = i + 1
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total || 0
            //that.dateList = resp.data.data.dateList || []
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    //获取当月时间
    getDateList() {
      // console.log(this.searchDate)
      var date = this.searchDate + '-01'
      var allDay = util.myTime.getMonthDay(date)
      var list = []
      for (var i = 0; i < allDay; i++) {
        var str = this.searchDate
        if (i < 9) {
          str = str + '-0' + (i + 1)
        } else {
          str = str + '-' + (i + 1)
        }
        list.push(str)
      }
      this.dateList = list
      // console.log(this.dateList)
    },
    //导出
    addRow() {
      // exportStatisMonth  以前的
      // var year1 = this.searchDate.split('-')[0]
      // var month1 = this.searchDate.split('-')[1]
      // 增加最长时长  最小时长
      var token = util.session.get('token')
      window.open(
        myHttp.exportFindAllMonthAttendInfo +
          '?projectId=' +
          this.projectId +
          '&teamsId=' +
          this.teamsId +
          // '&year1=' +
          // year1 +
          // '&month1=' +
          // month1 +
          '&name=' +
          this.name +
          '&minValue=' +
          this.minValue +
          '&maxValue=' +
          this.maxValue +
          '&month=' +
          this.searchDate +
          '&accessToken=' +
          token
      )
    },

    //获取统计数量
    getNum() {
      var that = this
      myHttp
        .countTeamsPersonInfo({
          month: this.searchDate,
          projectId: this.projectId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              that.allCount = resp.data.data
            }
          },
          function() {}
        )
    },
    filterName1(e) {
      this.minValue = e
      this.getDateList()
      this.getData()
      // this.getNum()
    },
    filterName2(e) {
      this.maxValue = e
      this.getDateList()
      this.getData()
      // this.getNum()
    },
     /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
  }
}
</script>

<style scoped>
.build-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
}
/* .build-bar div {
  margin-left: 30px;
} */
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  /* background: #fff; */
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table {
  height: calc(100% - 125px);
  /* position: absolute; */
}
.build-bar > .el-button {
  /* margin-left: 620px; */
  background-color: #17b2fe;
  border-color: #17b2fe;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
}
.tabP {
  text-align: left;
}
.selectMon {
  display: flex;
  line-height: 40px;
  /* margin-left: 100px !important; */
}
</style>
<style>
@import '../../assets/css/common.css';
</style>
